import { GatewayChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/charging-sessions/gateway-charging-session.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoChargingSessionListEmspUserFirstNameCell } from './emsp-bo-charging-session-list-emsp-user-first-name.cell';
import { EmspBoChargingSessionListEmspUserFirstNameHeader } from './emsp-bo-charging-session-list-emsp-user-first-name.header';

export const EmspBoChargingSessionListEmspUserFirstNameColumn: IdentifiedColumnDef<
  GatewayChargingSessionModel,
  GatewayChargingSessionModel['emspUser']['firstName']
> = {
  id: 'emspUserFirstName',
  enableSorting: false,
  header: EmspBoChargingSessionListEmspUserFirstNameHeader,
  cell: EmspBoChargingSessionListEmspUserFirstNameCell,
};
